export default __webpack_public_path__ + "static/media/flag-netherlands.dd75c694.svg";